import { View } from '@react-pdf/renderer'
import React from 'react'
import MainHeaderOne from './MainHeaderOne'

const MainHeader = ({data}) => {
  return (
    <View>
        <MainHeaderOne data={data}/>
        {/* <MainHeaderTwo data={data}/> */}
    </View>
  )
}

export default MainHeader